export function calculateSizeScale(perPageCount, totalSubjectsCount) {

  const perPage = parseInt(perPageCount as string);

  if (perPage === 1) {
      return 10; 
  } else if (perPage === 2) {
    //   console.log('inside perpage 2')
      if (totalSubjectsCount <= 5) {
        //   console.log('2 and less than 5')
          return 10;
      } else if (totalSubjectsCount === 6 || totalSubjectsCount === 7) {
          return 9;
      } else if (totalSubjectsCount >= 7 && totalSubjectsCount <= 9) {
          return 8;
      } else if (totalSubjectsCount >= 10 && totalSubjectsCount <= 12) {
          return 7;
      }
      return 6; 
  } else if (perPage === 3) {
      if (totalSubjectsCount === 1) {
          return 10;
      } else if (totalSubjectsCount === 2) {
          return 8;
      } else if (totalSubjectsCount === 3) {
          return 8;
      } else if (totalSubjectsCount === 4 || totalSubjectsCount === 5) {
          return 7;
      } else if (totalSubjectsCount === 6) {
          return 6;
      }
      return 5;
  } else if (perPage === 4) {
      if (totalSubjectsCount === 1) {
          return 6;
      }
      return 5; 
  } else {
    return 9;
  }
}
